import React from "react";
import { Button } from "react-bootstrap";

const Export = ({ onExport }) => <Button onClick={(e) => onExport(e.target.value)}>Exportar</Button>;

export default Export;
